import request from '@/utils/request'
const BASE_URL = '/Attachment'

export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  upload: BASE_URL + "/Upload",
  uploadFile(data) {
    return request({
      url: '/Common/UploadFile',
      method: 'post',
      headers: { "Content-Type": "multipart/form-data" },
      data
    })
  },
  delete(data) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  },
}